import { apiClient } from './apiClient';

const checkAuthToken = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (!token) {
    throw {
      status: 401,
      message: 'Authentication required. Please sign in to access profile details.',
    };
  }
  return token;
};

export const performLogout = () => {
  // 1. Clear all cookies
  try {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
      if (name) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname};`;
      }
    }
  } catch (e) {
    console.error('Failed to clear cookies:', e);
  }

  // 2. Clear localStorage
  try {
    localStorage.clear();
  } catch (e) {
    console.error('Failed to clear localStorage:', e);
  }

  // 3. Clear sessionStorage
  try {
    sessionStorage.clear();
  } catch (e) {
    console.error('Failed to clear sessionStorage:', e);
  }

  // 4. Redirect to home and refresh page
  window.location.href = '/';
};

export const authService = {
  async signup(username, password, fullName) {
    return apiClient.post('/auth/signup', {
      username,
      password,
      fullName,
    });
  },

  async login(username, password) {
    return apiClient.post('/auth/login', {
      username,
      password,
    });
  },

  async getUserProfile(userId) {
    checkAuthToken();
    return apiClient.get(`/user-profile/${userId}`);
  },

  async updateUserProfile(profileData) {
    checkAuthToken();
    return apiClient.put('/user-profile/update', profileData);
  },

  logout() {
    performLogout();
  },
};
